import { useEffect, useState } from "react"

import { useParams } from "react-router-dom"

import { useGeoServerFeaturesList } from "@l2r-front/l2r-geodata"
import { MAP_TYPE_ROAD, useMapContext } from "@l2r-front/l2r-map"
import { useIsMobileDevice } from "@l2r-front/l2r-ui"
import { NavigationOrigins, useApplicationStateContext, useNavigateWithSearchParams } from "@l2r-front/l2r-utils"

import { useNetworksStateContext } from "../../contexts/NetworksContext"
import { networksQueryKeys, useGetAvailableSubnetworkForModule, useRoadBoundingBox } from "../../hooks"

export const MapAdapterRoad = (props) => {

    const {
        backUrl = "..",
        module,
    } = props

    const navigate = useNavigateWithSearchParams()
    const { road } = useParams()
    const [mapState, mapDispatch] = useMapContext()
    const { getMapRef, resetMapBoundingBox, setMapType, setMapBoundingBoxToFit, restoreMapBoundingBox } = mapDispatch
    const { storedBoundingBox } = mapState
    const mapRef = getMapRef()
    const { selectedNetwork } = useNetworksStateContext()
    const { navigationOrigin } = useApplicationStateContext()
    const [isBBSet, setIsBBSet] = useState(false)
    const isMobile = useIsMobileDevice()
    const roadBoundingBox = useRoadBoundingBox(road)

    const availableSubNetworksSlugs = useGetAvailableSubnetworkForModule(module)
    const queryKeyParams = { road, availableSubNetworksSlugs }
    const { data: roadSegments, isError, isLoading, refetch } = useGeoServerFeaturesList(
        networksQueryKeys.list(queryKeyParams),
        {
            layer: selectedNetwork?.referential?.layerSection,
            linear_location_road: road,
            sub_network_slugs: availableSubNetworksSlugs,
        },
        {
            enabled: !!road && !!selectedNetwork?.referential,
        })

    useEffect(() => {
        setMapType(MAP_TYPE_ROAD)
    }, [setMapType])

    useEffect(() => {
        if (road && selectedNetwork) {
            setIsBBSet(false)
            refetch()
        }
    }, [road, selectedNetwork, refetch])

    useEffect(() => {
        if (!isLoading && (!roadSegments?.length || isError)) {
            return navigate(backUrl)
        }
        return
    }, [backUrl, roadSegments, isError, isLoading, navigate])

    useEffect(() => {
        if (mapRef && !isBBSet) {
            if (storedBoundingBox.road) {
                restoreMapBoundingBox(MAP_TYPE_ROAD)
                setIsBBSet(true)
            } else if (roadBoundingBox) {
                const map = mapRef.getMap()
                const newCameraWithBounds = map.cameraForBounds([
                    [roadBoundingBox.minLng, roadBoundingBox.minLat],
                    [roadBoundingBox.maxLng, roadBoundingBox.maxLat],
                ])

                switch (navigationOrigin) {
                    case NavigationOrigins.ROAD_FROM_DETAIL:
                        break
                    case NavigationOrigins.ROAD_FROM_ROAD:
                        break
                    case NavigationOrigins.ROAD_FROM_NETWORK:
                        if (isMobile) {
                            const previousZoom = storedBoundingBox?.network?.zoom
                            if (!previousZoom || newCameraWithBounds.zoom > storedBoundingBox.network.zoom) {
                                setMapBoundingBoxToFit(roadBoundingBox)
                            } else {
                                setMapBoundingBoxToFit(storedBoundingBox.network)
                            }
                        } else if (newCameraWithBounds?.zoom > map.getZoom()) {
                            setMapBoundingBoxToFit(roadBoundingBox)
                        }
                        break
                    case NavigationOrigins.ROAD_FROM_BACK_DETAIL:
                        break
                    case NavigationOrigins.ROAD_FROM_SEARCH:
                        setMapBoundingBoxToFit(roadBoundingBox)
                        break
                    case NavigationOrigins.NONE:
                        setMapBoundingBoxToFit(roadBoundingBox)
                        break
                }
                resetMapBoundingBox()
                return setIsBBSet(true)
            }
        }
    }, [isMobile,
        mapRef,
        navigationOrigin,
        resetMapBoundingBox,
        roadBoundingBox,
        setMapBoundingBoxToFit,
        storedBoundingBox,
        restoreMapBoundingBox,
        isBBSet,
        setIsBBSet,
    ])

    return null
}